import React, { useEffect, useState, useContext } from 'react';
import AccountHeader from '../Presentation/AccountHeader';
import OrderHistory from '../Presentation/OrderHistory';
import { isMobileDevice } from 'common/utilities/utils';
import AccountSettings from '../Presentation/AccountSettings';
import FavouriteOrderComponent from '../Presentation/FavouriteOrderComponent';
import AddressStoresContainer from '../Presentation/AddressesAndStores/AddressStoresContainer';
import ORDER_HISTORY from '../Constants/Constants';
import { UserOrderContext } from 'context/context';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';

const AccountComponent = ({ history, setShowKfcHeader }) => {
  const { ACCOUNT_SETTING, ORDER_HISTORY_TAG, ADDRESS, MY_FAV_MENU } = ORDER_HISTORY;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [currentMenuName, setMenuName] = useState('');
  const { userOrderState } = useContext(UserOrderContext);

  useEffect(() => {
    window.addEventListener('resize', () => {
      const isMobileView = isMobileDevice(window.innerWidth);
      setMobileHeader(isMobileView);
    });
  }, [isMobile]);

  useEffect(() => {
    const localdata = localStorage.getItem('LoadMoreOrderHistory');
    if (localdata === 'GoToOrderHistory' || history.location.isNavigatingFromReorder === true) {
      setMenuName(ORDER_HISTORY_TAG);
    }
    return () => {
      localStorage.removeItem('LoadMoreOrderHistory');
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderSwitch = param => {
    switch (param) {
      case ACCOUNT_SETTING:
        setShowKfcHeader(false);
        return <AccountSettings updateMenu={data => setMenuName(data)} history={history} />;
      case ORDER_HISTORY_TAG:
        setShowKfcHeader(false);
        return <OrderHistory isMobile={isMobile} renderSwitch={renderSwitch} updateMenu={data => setMenuName(data)} />;
      case ADDRESS:
        setShowKfcHeader(false);
        return <AddressStoresContainer history={history} isMobile={isMobile} updateMenu={data => setMenuName(data)} />;
      case MY_FAV_MENU:
        setShowKfcHeader(false);
        return (
          <FavouriteOrderComponent
            isMobile={isMobile}
            updateMenu={data => setMenuName(data)}
            currentMenu={currentMenuName}
          />
        );
      default:
        setShowKfcHeader(true);
        return isMobile ? (
          <AccountHeader
            isMobile={isMobile}
            currentMenu={currentMenuName}
            updateMenu={data => setMenuName(data)}
            history={history}
          />
        ) : (
          <OrderHistory isMobile={isMobile} renderSwitch={renderSwitch} updateMenu={data => setMenuName(data)} />
        );
    }
  };

  const desktopAccountSection = () => {
    return (
      <div className='account-desktop-container mt-5 grid-container'>
        <div className='account-section-left'>
          <AccountHeader
            isMobile={isMobile}
            currentMenu={currentMenuName}
            updateMenu={data => setMenuName(data)}
            history={history}
          />
        </div>
        <div className='account-section-right'>{renderSwitch(currentMenuName)}</div>
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  const mobileAccountSection = () => {
    return (
      <div className='mobile-order-history'>
        {renderSwitch(currentMenuName)}
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  return isMobile ? mobileAccountSection() : desktopAccountSection();
};

export default AccountComponent;
